module.exports = __webpack_public_path__ + "img/logo-lg-dark.266c7151.svg";